import React from "react";

import Board2Presenter from "./Board2Presenter";

export default class extends React.Component {

  render() {
    return <Board2Presenter />;
  }
}
